export const DEFAULT_NOTIFICATIONS = {};
//# sourceMappingURL=model.js.map